{
  "name": "bp-web-components",
  "version": "0.24.0",
  "description": "Web components for The Bible Project Classroom visuals ",
  "license": "UNLICENSED",
  "type": "module",
  "main": "index.js",
  "engines": {
    "node": ">=24"
  },
  "scripts": {
    "build": "npm run clean && tsx scripts/build.ts",
    "clean": "rm -rf dist",
    "dev:serve": "tsx scripts/serve.ts",
    "dev:watch": "npm run build -- --watch",
    "dev": "run-p dev:*",
    "format": "prettier --write .",
    "lint": "eslint --cache --cache-location ./node_modules/.cache/eslint .",
    "prepare": "husky install",
    "storybook": "storybook dev -p 6006 --no-open",
    "storybook:build": "storybook build",
    "test": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc -b"
  },
  "dependencies": {
    "@lit-labs/observers": "^2.0.5",
    "classnames": "^2.3.2",
    "focus-trap": "^7.6.5",
    "hls.js": "^1.6.5",
    "idb": "^7.1.1",
    "lit": "^2.8.0"
  },
  "devDependencies": {
    "@babel/core": "^7.27.4",
    "@mswjs/http-middleware": "^0.8.0",
    "@storybook/addon-docs": "^9.0.11",
    "@storybook/web-components-vite": "^9.0.11",
    "@testing-library/jest-dom": "^6.0.0",
    "@testing-library/user-event": "^14.6.1",
    "@types/cors": "^2.8.19",
    "@types/express": "^5.0.3",
    "@types/fs-extra": "^11.0.1",
    "@typescript-eslint/eslint-plugin": "^6.4.0",
    "@typescript-eslint/parser": "^6.4.0",
    "@vitest/coverage-v8": "^3.1.4",
    "chokidar": "^3.5.3",
    "chromatic": "^12.0.0",
    "cors": "^2.8.5",
    "cross-fetch": "^4.1.0",
    "dotenv": "^16.5.0",
    "esbuild": "^0.24.0",
    "eslint": "^8.47.0",
    "eslint-plugin-import": "^2.28.0",
    "eslint-plugin-storybook": "^9.0.11",
    "express": "^4.21.0",
    "fake-indexeddb": "^4.0.2",
    "fs-extra": "^11.3.0",
    "globby": "^13.2.2",
    "husky": "^9.1.7",
    "jsdom": "^22.1.0",
    "lint-staged": "^15.2.10",
    "msw": "^2.8.6",
    "msw-storybook-addon": "^2.0.5",
    "npm-run-all": "^4.1.5",
    "prettier": "^3.5.3",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "storybook": "^9.0.11",
    "tsx": "^4.20.3",
    "typescript": "^5.8.3",
    "vite": "^6.4.1",
    "vite-tsconfig-paths": "^5.1.4"
  },
  "msw": {
    "workerDirectory": "public"
  }
}
